import { NgModule } from "@angular/core";
import { TermsAndConditionsComponent } from "./terms-and-conditions/terms-and-conditions.component";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { UiModule } from "./ui.module";
import { PdfViewerModule } from "ng2-pdf-viewer";

@NgModule({
    declarations: [TermsAndConditionsComponent],
    imports: [
    CommonModule,
    IonicModule,
    UiModule,
    PdfViewerModule
],
    exports: [TermsAndConditionsComponent]
})
export class TermsAndConditionsModule { }